import { withStyles } from '@material-ui/core';

import ButtonSet from './component';
import styles from './styles';

export default withStyles(styles)(ButtonSet);
